import { Redirect, Route } from "react-router-dom";
import React from "react";
import { Loader } from "semantic-ui-react";
import URI from "urijs";
import { to } from "./Url";
import { useAuth } from "./Auth";

export function PrivateRoute({ children, ...rest }) {
  const { user, isPending } = useAuth();

  if (isPending) return <Loader active inline="centered" />;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export const Login = ({ location }) => {
  const { loading, error } = useAuth();
  const { from } = location.state || { from: { pathname: "/" } };

  if (loading) return null;

  if (error) {
    const target = new URI("/accounts/login/");
    target.addQuery("next", to(from.pathname));
    window.location.href = to(target);
    return null;
  } else {
    return <Redirect to={from} />;
  }
};
